/* eslint no-template-curly-in-string: 0 */
// import starbucksGiftCard from "../../assets/images/starbucks-gift-card.png";
import starbucksGiftCard from "../../assets/images/starbucks-alt-core-card.jpg";
import { FLOW_TYPES, PAYMENT_STATUSES } from "../../utils/enums";

const aboutNetworkFaq = {
  answer: "Treat yourself - or someone else - to something special at Starbucks with a Starbucks Card, which you can use towards premium coffee, tea, refreshers, lunch, pastries and more. And if you register your card and join Starbucks® Rewards (<a href=\"https://www.starbucks.com/rewards\">www.starbucks.com/rewards</a>), you can earn even more free food and drinks. <br/><br/>Treat this Card like cash. Reload your Card, check your balance and find out how to register and protect your Card balance at participating stores, <a href=\"https://www.starbucks.com\">Starbucks.com</a> or <a href=\"tel:+1-800-782-7282\">1-800-782-7282</a>. Cannot be redeemed for cash unless required by law. Refunds only provided for unused Cards with the original receipt. This Card does not expire, nor does Starbucks charge fees. Use of this Card constitutes acceptance of the terms and conditions available at <a href=\"https://www.starbucks.com/cardterms\">www.starbucks.com/cardterms</a>, including arbitration terms. Printed in the USA.",
  question: "About Starbucks® eGiftCard"
};

export const starbucks = {
  id: "EGIFT_BLACKHAWK_STARBUCKS",
  displayName: "Starbucks eGiftCard",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Starbucks eGiftCard™",
      tagline: "Enjoy your favorite coffee or treat today",
      description: [
        {
          string: "Treat yourself or someone else to ",
          type: "div",
        },
        {
          string: "something special at Starbucks",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: starbucksGiftCard
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Starbucks eGiftCard™"
    }
  },
  acceptPayment: {
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    btnLabel: "GET MY STARBUCKS CARD",
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Starbucks eGiftCard which will be emailed to ",
      {
        string: "${payment.recipientEmail}",
        props: {
          className: 'payment-recipientEmail'
        },
      },
      "."
    ],
    imgSrc: starbucksGiftCard
  },
  networkSelectionAccepted: {
    imgSrc: starbucksGiftCard,
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email for your ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " for details regarding your ",
        {
          string: "Starbucks eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ". It should arrive soon and will include details for your use.",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt',
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Starbucks eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: starbucksGiftCard,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: starbucksGiftCard,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default starbucks;
